/* eslint-disable @typescript-eslint/no-explicit-any */
// (we maybe want to look into getting the types from contentful at some point)
import { documentToHtmlString } from '@contentful/rich-text-html-renderer'
// eslint-disable-next-line @typescript-eslint/no-var-requires
const contentful = require('contentful')

export interface Faq {
    question: string
    richAnswer: string
}

export interface ExpandableFaqItem extends Faq {
    expanded: boolean
    id: number
}
export interface Image {
    title: string
    url: string
    description?: string
}
export interface TrustedBy {
    title: string
    image: Image
}
export interface Collection {
    title: string
    image: Image
}
export interface Session {
    title: string
    quote: string
    richQuote: string
    image?: Image
    images?: Image[]
    trustedBy?: TrustedBy[]
    collections?: Collection[]
    subSections?: Session[]
}
export interface HowItWorks {
    title: string
    quote: string
    icon: string
}

export interface Page {
    sessions: Session[]
    faq: Faq[]
    howItWorks: HowItWorks[]
}

const clients: { [key: string]: any } = {
    ['live']: contentful.createClient({
        space: process.env.NEXT_PUBLIC_CONTENTFUL_SPACE,
        accessToken: process.env.NEXT_PUBLIC_CONTENTFUL_ACCESSKEY,
    }),
    preview: contentful.createClient({
        space: process.env.NEXT_PUBLIC_CONTENTFUL_SPACE,
        accessToken: process.env.NEXT_PUBLIC_CONTENTFUL_PREVIEW_ACCESSKEY,
        host: process.env.NEXT_PUBLIC_CONTENTFUL_PREVIEW_HOST,
    }),
}

const schema = process.env.NEXT_PUBLIC_CONTENTFUL_IMAGE_SCHEMA

export const getImage = (image: string, isPreview: boolean): Promise<Image> => {
    const client = clients[isPreview ? 'preview' : 'live']
    return client
        .getAsset(image)
        .then(mapImage)
        .catch((err: Error) => console.error(err))
}

const mapImage = (image: any) => {
    return {
        title: image.fields.title,
        url: schema + ':' + image.fields.file.url,
        description: image.fields.description,
    }
}

const mapSection = (item: any): Session => {
    const image = item.fields.image ? mapImage(item.fields.image) : undefined

    const images = item.fields.images
        ? item.fields.images.map(mapImage)
        : undefined

    const trustedBy = item.fields.trustedBy
        ? item.fields.trustedBy.fields.trustedBy.map((item: any) => {
              const trustedByItem: TrustedBy = {
                  title: item.fields.title,
                  image: {
                      title: item.fields.image.fields.title,
                      url: schema + ':' + item.fields.image.fields.file.url,
                  },
              }
              return trustedByItem
          })
        : undefined
    const collections = item.fields.collections
        ? item.fields.collections.fields.collections.map((item: any) => {
              const collectionItem: Collection = {
                  title: item.fields.title,
                  image: {
                      title: item.fields.image.fields.title,
                      url: schema + ':' + item.fields.image.fields.file.url,
                  },
              }
              return collectionItem
          })
        : undefined

    const subSections = item.fields.subSections
        ? item.fields.subSections.map(mapSection)
        : undefined

    return {
        title: item.fields.title,
        quote: item.fields.quote,
        richQuote: item.fields.richQuote
            ? documentToHtmlString(item.fields.richQuote)
            : '',
        image: image,
        images: images,
        trustedBy: trustedBy,
        collections: collections,
        subSections: subSections,
    }
}

export const getEntries = (page: string, isPreview: boolean): Promise<Page> => {
    const client = clients[isPreview ? 'preview' : 'live']
    return client
        .getEntries({ content_type: 'page', 'fields.slug': page, include: 10 })
        .then((entry: any) => {
            const faq: Faq[] = entry.items[0].fields.faqSection
                ? entry.items[0].fields.faqSection.fields.questionsAndAnswers.map(
                      (item: any) => {
                          const test: Faq = {
                              question: item.fields.question,
                              richAnswer: documentToHtmlString(
                                  item.fields.richAnswer
                              ),
                          }
                          return test
                      }
                  )
                : undefined

            const howItWorks: HowItWorks[] = entry.items[0].fields
                .howItWorksSection
                ? entry.items[0].fields.howItWorksSection.fields.howItWorksList.map(
                      (item: any) => {
                          const test: HowItWorks = {
                              title: item.fields.title,
                              quote: documentToHtmlString(item.fields.quote),
                              icon: item.fields.icon.fields.icon,
                          }
                          return test
                      }
                  )
                : undefined

            const sessions: Session[] =
                entry.items[0].fields.sections?.map(mapSection)
            return { sessions: sessions, faq: faq, howItWorks: howItWorks }
        })
        .catch((err: Error) => console.error(err))
}
